import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import {
  DEFAULT_TABLE_CELLS,
  FLOOR_PLAN_COLS,
  FLOOR_PLAN_ROWS,
  MIN_PLACEMENT_CELLS,
} from '../../utils/floorPlan';
/** A single table within a floor plan. Geometry is in grid cells; rotation in degrees. */
export const tablePlacementSchema = z.object({
  /** Short label shown on the canvas, e.g. "1", "1A". */
  label: z.string(),
  uuid: z.string().default(() => uuidv4()),

  x: z.number().int().default(0),
  y: z.number().int().default(0),
  width: z.number().int().default(DEFAULT_TABLE_CELLS),
  height: z.number().int().default(DEFAULT_TABLE_CELLS),
  rotation: z.number().default(0),
  shape: z.literal(['rectangle', 'rounded']).default('rectangle'),
});
export type TablePlacement = z.output<typeof tablePlacementSchema>;

/** Strict schema */
export const tablePlacementStrictSchema = tablePlacementSchema.safeExtend({
  label: z
    .string()
    .min(1)
    .max(3)
    .regex(/^[A-Z0-9]+$/, 'Only letters A-Z and numbers 0-9, no spaces'),
  uuid: z.guid(),
  width: z.int().min(MIN_PLACEMENT_CELLS).max(FLOOR_PLAN_COLS),
  height: z.int().min(MIN_PLACEMENT_CELLS).max(FLOOR_PLAN_ROWS),
});

/** Convex schema */
export const tablePlacementCvxSchema = tablePlacementSchema;
export type TablePlacementCvx = z.output<typeof tablePlacementCvxSchema>;
